import sty from "../notasSelecao.module.css"

export default function NotasEmpresaInfo({ notas, empresa }: iProps) {
    // let competenciaAux = ""
    // if (competencia.length === 7) {
    //     const comp = competencia.split("/")
    //     competenciaAux = `${comp[1]}-${comp[0]}`
    // }

    const moneyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })

    const notas_pendentes = notas.filter((reg: any) => reg.status === "Não Emitido" || reg.status === "Erro ao Emitir")
    let valor_pendente_aux = 0
    for (let nota of notas_pendentes) {
        const valor_servicos = String(nota.valor_servicos).replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
        valor_pendente_aux = valor_pendente_aux + Number(valor_servicos)
    }
    const valor_pendente = moneyFormatter.format(valor_pendente_aux)

    const notas_emitidas = notas.filter((reg: any) => reg.status === "Emitido")
    let valor_emitido_aux = 0
    for (let nota of notas_emitidas) {
        const valor_servicos = String(nota.valor_servicos).replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
        valor_emitido_aux = valor_emitido_aux + Number(valor_servicos)
    }
    const valor_total = moneyFormatter.format(valor_emitido_aux)

    const notas_canceladas = notas.filter((reg: any) => reg.status === "Emitido (Cancelado)")
    let valor_cancelado_aux = 0
    for (let nota of notas_canceladas) {
        const valor_servicos = String(nota.valor_servicos).replaceAll("R$ ", "").replaceAll(".", "").replaceAll(",", ".")
        valor_cancelado_aux = valor_cancelado_aux + Number(valor_servicos)
    }
    const valor_cancelado = moneyFormatter.format(valor_cancelado_aux)

    return (
        <div className="div-row">
            <div id={sty.empresaResumoDiv}>
                <div className={sty.empresaResumoValor} style={{ backgroundColor: notas_emitidas.length > 0 ? "rgba(167,201,87, .5)" : "#dedede" }}>
                    <h2>{valor_total}</h2>
                    <p>Notas Emitidas ({notas_emitidas.length})</p>
                </div>
                <div className={sty.empresaResumoValor} style={{ backgroundColor: notas_pendentes.length > 0 ? "rgba(245, 233, 67, 0.5)" : "#dedede" }}>
                    <h2>{valor_pendente}</h2>
                    <p>Notas Pendentes ({notas_pendentes.length})</p>
                </div>
                <div className={sty.empresaResumoValor} style={{}}>
                    <h2>{valor_cancelado}</h2>
                    <p>Notas Canceladas ({notas_canceladas.length})</p>
                </div>
            </div>
            {/* <div style={{ borderLeft: "1px solid #dedede", height: "128px", marginLeft: "30px" }}></div> */}
            {/* {
                competenciaAux === empresa.info.competencia &&
                <div id={sty.empresaResumoDiv}>
                    <div className={sty.empresaResumoValor}>
                        <h2>{empresa.info.valor_total_anterior}</h2>
                        <p>Notas Emitidas ({empresa.info.qtd_emitidas_anterior}) (mês anterior)</p>
                    </div>
                    <div className={sty.empresaResumoValor} style={{ backgroundColor: empresa.info.qtd_pendentes_anterior > 0 ? "rgba(245, 233, 67, 0.5)" : "#dedede" }}>
                        <h2>{empresa.info.valor_pendente_anterior}</h2>
                        <p>Notas Pendentes ({empresa.info.qtd_pendentes_anterior}) (mês anterior)</p>
                    </div>
                </div>
            } */}
        </div>
    )
}

interface iProps {
    notas: any[]
    empresa: any
}